var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-card',{attrs:{"name":"user.timeline","rounded":"","error":_vm.error}},[_c('div',{attrs:{"slot":"controls"},slot:"controls"},[_c('timeline-datepicker')],1),(_vm.hasCurrent)?_c('timeline-current'):_vm._e(),_c('timeline-items')],1)}
var staticRenderFns = []

export { render, staticRenderFns }